export default __webpack_public_path__ + "static/1296-3f502d1455cc539033a67b8c9ab858fe.gif";